import { isEqual } from 'lodash-es';

import { getEntityStringByNgType } from '@editor2/services/conflictResolutionService';
import { ConflictType } from '@editor2/types/conflict';
import { type CourseState } from '@editor2/types/courseState';
import { NgTraditional } from '@editor2/types/ngTraditional';

export const recalculateConflictsHelper = (state: CourseState) => {
	state.conflicts.map((conflict, index) => {
		const { entityId, entityType, attribute, current, conflictType } = conflict;

		const entityString = getEntityStringByNgType(entityType);

		switch (conflictType) {
			case ConflictType.Property: {
				const currentValue =
					entityType === NgTraditional.Book
						? state.book[attribute]
						: state[entityString].entities[entityId][attribute];

				if (!isEqual(currentValue, current)) state.conflicts[index].current = currentValue;
				break;
			}

			case ConflictType.ChildrenReorder: {
				const currentValue =
					entityType === NgTraditional.Book
						? state.chapters.ids // chapter reorder
						: state[entityString].entities[entityId][attribute];

				if (!isEqual(currentValue, current)) state.conflicts[index].current = currentValue;
				break;
			}

			case ConflictType.ModifiedDeleted: {
				const currentValue: any = state[entityString].entities[entityId]; // whole entity object

				if (!isEqual(currentValue, current)) state.conflicts[index].current = currentValue;
				break;
			}

			case ConflictType.DeletedModified: {
				break;
			}

			default:
				break;
		}
	});

	return state;
};
